import {Branch} from './branch';

export class Customer {

    id: number;
    user_id: number;
    email: string = '';
    customer_id: string = '';
    title: string = '';
    branch: Branch = new Branch();
    first_name: string = '';
    last_name: string = '';
    fullname = '';
    phone: string = '';
    fax: string = '';
    street: string = '';
    zip: string = '';
    city: string = '';
    country: string = '';
    comments: string = '';
    birthdate: string = '';


}
